import { render, staticRenderFns } from "./EditableFreeCostComponent.vue?vue&type=template&id=6e81f288&scoped=true"
import script from "./EditableFreeCostComponent.vue?vue&type=script&lang=js"
export * from "./EditableFreeCostComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e81f288",
  null
  
)

export default component.exports